<div *ngIf="params?.node?.isError">
  <button mat-icon-button
    [matTooltip]="params?.node?.validationToolTip"
    matTooltipPosition="after"
    [matTooltipClass]="'validation-warning-tooltip'"
    class="error-button">
    <mat-icon>warning</mat-icon>
  </button>
</div>
